<template>
  <el-dialog
    append-to-body
    title="修改登录密码"
    :visible="visible"
    width="480px"
    :close-on-click-modal="false"
    class="page-dialog"
    @closed="handleClosed"
    @close="$emit('update:visible', false)"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="80px" label-position="right" size="small">
      <el-form-item label="会员账号" prop="account">
        <el-input v-model="form.account" placeholder="请输入会员账号" disabled />
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input v-model="form.password" placeholder="请输入新密码" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { MemberApi } from '@/api/member/member'

export default {
  name: 'ModifyLoginPasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        account: '',
        password: '',
      },
      rules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {
            validator(rule, value, callback) {
              const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,12}$/
              if (!value) {
                callback()
              } else if (!reg.test(value)) {
                callback(new Error('密码需为6-12位数字字母组合'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    userInfo: {
      handler(newVal) {
        this.form.account = newVal.account
      },
      immediate: true,
    },
  },
  methods: {
    handleCancel() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleConfirm() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          const params = {
            password: this.form.password,
            uid: this.userInfo.uid,
          }

          const response = await MemberApi.modifyLoginPassword(params)

          if (response.code === 0) {
            this.$message.success('修改登录密码成功')
            this.$emit('update:visible', false)
            this.$emit('close')
          }
        }
      })
    },
    handleClosed() {
      // 重置表单和数据
      this.$refs.formRef.resetFields()
    },
  },
}
</script>

<style scoped></style>
